// extracted by mini-css-extract-plugin
export default {"registration":"tpmuVwqi","hide":"G0ndqSN7","form":"KWgnNmvn","field":"aOTuOTej","buttonsWrapper":"zeT7VEYP","button":"yNTqUu77","button2":"YZOXYeNe","button3":"NNq1Zyr9","title":"iBqRp0R9","success":"e5bax29N","requestMessage":"kED1lFyo","noMb":"ovY760sC"};
    if(module.hot) {
      // 1738090063598
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  